import React from 'react';
import { Stack, IconButton } from '@fluentui/react';
import { BACKGROUND_IMAGES } from '../PersonalMeetingCorner.state';
import { styles } from '../PersonalMeetingCorner.styles';
import { useIsBottomImageExpanded, useIsUserAloneInOwnPersonalRoom, useTopImageIndex } from '../states/hooks';

interface Props {
    isLoaded: boolean;
    setIsLoaded: (loaded: boolean) => void;
}

const TopImageSection: React.FC<Props> = ({ isLoaded, setIsLoaded }) => {
    const [topImageIndex, setTopImageIndex] = useTopImageIndex();
    const isUserAloneInOwnPersonalRoom = useIsUserAloneInOwnPersonalRoom();
    const [isBottomImageExpanded] = useIsBottomImageExpanded();
    return (
        <Stack className={styles.top} style={{ height: isBottomImageExpanded ? '58vh' : '87vh' }}>
            <Stack className={styles.imageContainer}>
                <img
                    src={BACKGROUND_IMAGES[topImageIndex]}
                    className={styles.image}
                    style={{ opacity: isLoaded ? 1 : 0, objectFit: isBottomImageExpanded ? 'cover' : 'fill' }}
                    onLoad={() => setIsLoaded(true)}
                    alt="Wall"
                    draggable={false}
                />
            </Stack>
            {isUserAloneInOwnPersonalRoom && (
                <>
                    <IconButton
                        className={`${styles.navButton} ${styles.leftNav}`}
                        iconProps={{ iconName: 'ChevronLeft' }}
                        onClick={() => {
                            setIsLoaded(false);
                            setTopImageIndex(topImageIndex === 0 ? BACKGROUND_IMAGES.length - 1 : topImageIndex - 1);
                        }}
                    />
                    <IconButton
                        className={`${styles.navButton} ${styles.rightNav}`}
                        iconProps={{ iconName: 'ChevronRight' }}
                        onClick={() => {
                            setIsLoaded(false);
                            setTopImageIndex(topImageIndex === BACKGROUND_IMAGES.length - 1 ? 0 : topImageIndex + 1);
                        }}
                    />
                </>
            )}
        </Stack>
    );
};

export default TopImageSection;
